import { render, staticRenderFns } from "./_info.vue?vue&type=template&id=25cb2c97"
import script from "./_info.vue?vue&type=script&lang=js"
export * from "./_info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports